
import { routes_names, layout_names } from '../constants'
// layouts
import AuthLayout from '@/layouts/Auth.vue'
import PublicLayout from '@/layouts/Public.vue'
import DashboardLayout from '@/layouts/Dashboard.vue'

export const routes = [
  // public
  {
    path: '/',
    name: layout_names.public,
    component: PublicLayout,
    redirect: {
      name: routes_names.uptimekuma_dashboard
    },
    children: [
      {
        path: '/uptime-kuma-dashboard',
        name: routes_names.uptimekuma_dashboard,
        component: () => import('@/views/public/UptimeKumaServicesDashboard.vue'),
        meta: {
          title: 'Uptime Kuma Dashboard',
          public: true,
        },
      },
      {
        path: '/esxi-servers-dashboard',
        name: routes_names.esxi_servers_dashboard,
        component: () => import('@/views/public/EsxiServersDashboard.vue'),
        meta: {
          title: 'Esxi Servers Dashboard',
          public: true,
        },
      },
      {
        path: '/ipmi-servers-dashboard',
        name: routes_names.ipmi_servers_dashboard,
        component: () => import('@/views/public/IpmiServersDashboard.vue'),
        meta: {
          title: 'Ipmi Servers Dashboard',
          public: true,
        },
      },
      {
        path: '/ilo-servers-dashboard',
        name: routes_names.ilo_servers_dashboard,
        component: () => import('@/views/public/IloServersDashboard.vue'),
        meta: {
          title: 'Ilo Servers Dashboard',
          public: true,
        },
      },
      {
        path: '/call-fail',
        name: routes_names.call_fail,
        component: () => import('@/views/public/CallFail.vue'),
        meta: {
          title: 'Ilo Servers Dashboard',
          public: true,
        },
      },
      {
        path: '/check-fail',
        name: routes_names.check_fail,
        component: () => import('@/views/public/CheckFail.vue'),
        meta: {
          title: 'Ilo Servers Dashboard',
          public: true,
        },
      },
      {
        path: '/check-redis-fail',
        name: routes_names.check_redis_fail,
        component: () => import('@/views/public/CheckRedisFail.vue'),
        meta: {
          title: 'Ilo Servers Dashboard',
          public: true,
        },
      }
    ],
  },
  // auth
  {
    path: '/',
    name: layout_names.authorization,
    component: AuthLayout,
    redirect: {
      name: routes_names.login
    },
    children: [
      {
        path: '/login',
        name: routes_names.login,
        component: () => import('@/views/auth/Login.vue'),
        meta: {
          title: 'Login',
        },
      }
    ],
    meta: {
      notRequiresAuth: true,
    },
  },
  // main user
  {
    path: '/',
    name: layout_names.dashboard,
    component: DashboardLayout,
    redirect: {
      name: routes_names.main
    },
    children: [
      {
        path: '/dashboard',
        name: routes_names.main,
        component: () => import('@/views/app/index.vue'),
        meta: {
          title: 'Dashboard',
        },
      },
      {
        path: '/cp-detect/pincodes',
        name: routes_names.cp_detect_pincodes,
        component: () => import('@/views/app/cp-detect/Pincodes.vue'),
        meta: {
          title: 'Pincodes',
        },
      },
      {
        path: '/cp-detect/centeral-points',
        name: routes_names.cp_detect_centeral_points,
        component: () => import('@/views/app/cp-detect/CenteralPoints.vue'),
        meta: {
          title: 'Centeral Points',
        },
      },
      {
        path: '/cp-detect/document-approvals',
        name: routes_names.cp_detect_document_approvals,
        component: () => import('@/views/app/cp-detect/DocumentApproval.vue'),
        meta: {
          title: 'Document Approvals',
        },
      },
      {
        path: '/error-capture/allowed-domains',
        name: routes_names.error_capture_cors_allowed_domains,
        component: () => import('@/views/app/error-capture/CORSAllowedDomain.vue'),
        meta: {
          title: 'CORS allowed domain',
        },
      },
      {
        path: '/error-capture/sip-incoming-call-tests',
        name: routes_names.error_capture_sip_incoming_call_tests,
        component: () => import('@/views/app/error-capture/SipIncomingCallTests.vue'),
        meta: {
          title: 'CORS allowed domain',
        },
      },
      {
        path: '/error-capture/errors',
        name: routes_names.error_capture_errors,
        component: () => import('@/views/app/error-capture/Errors.vue'),
        meta: {
          title: 'Errors',
        },
      },
      {
        path: '/error-capture/web-sip-logs',
        name: routes_names.error_capture_web_sip_logs,
        component: () => import('@/views/app/error-capture/WebSipLogs.vue'),
        meta: { title: 'Web SIP Logs', requiresAuth: true },
      },
      {
        path: '/error-capture/sip-logs',
        name: routes_names.error_capture_sip_logs,
        component: () => import('@/views/app/error-capture/SipLogs.vue'),
        meta: {
          title: 'SIP Logs',
        },
      },
      {
        path: '/error-capture/user-actions',
        name: routes_names.error_capture_user_actions,
        component: () => import('@/views/app/error-capture/UserActions.vue'),
        meta: {
          title: 'User Actions',
        },
      },
      {
        path: '/error-capture/uptime-kuma-services',
        name: routes_names.error_capture_uptime_kuma_services,
        component: () => import('@/views/app/error-capture/UptimeKumaServices.vue'),
        meta: {
          title: 'Uptime Kuma Services',
        },
      },
      {
        path: '/error-capture/agents',
        name: routes_names.error_capture_agents,
        component: () => import('@/views/app/error-capture/Agents.vue'),
        meta: {
          title: 'Agents',
        },
      },
      {
        path: '/automation/credentials',
        name: routes_names.automation_credentials,
        component: () => import('@/views/app/automation/Credentials.vue'),
        meta: {
          title: 'Credentials',
        },
      },
      {
        path: '/automation/servers',
        name: routes_names.automation_servers,
        component: () => import('@/views/app/automation/Servers.vue'),
        meta: {
          title: 'Servers',
        },
      },
      {
        path: '/automation/loud-test',
        name: routes_names.automation_loud_test,
        component: () => import('@/views/app/automation/LoudTest.vue'),
        meta: {
          title: 'Loud Test',
        },
      },
      {
        path: '/universal-ai/servers',
        name: routes_names.universal_ai_servers,
        component: () => import('@/views/app/universal-ai/Server.vue'),
        meta: {
          title: 'Servers',
        },
      },
      {
        path: '/universal-ai/api-keys',
        name: routes_names.universal_ai_api_keys,
        component: () => import('@/views/app/universal-ai/ApiKey.vue'),
        meta: {
          title: 'Api Keys',
        },
      },
      {
        path: '/universal-ai/logs',
        name: routes_names.universal_ai_logs,
        component: () => import('@/views/app/universal-ai/Logs.vue'),
        meta: {
          title: 'Logs',
        },
      },
      {
        path: '/call-stats/filters',
        name: routes_names.call_stats_filters,
        component: () => import('@/views/app/call-stats/Filters.vue'),
        meta: {
          title: 'Filters',
        },
      },
      {
        path: '/call-stats/thresholds',
        name: routes_names.call_stats_thresholds,
        component: () => import('@/views/app/call-stats/Thresholds.vue'),
        meta: {
          title: 'Thresholds',
        },
      },
      {
        path: '/call-stats/sip-servers',
        name: routes_names.call_stats_sip_servers,
        component: () => import('@/views/app/call-stats/SipServers.vue'),
        meta: {
          title: 'Sip Servers',
        },
      },
      {
        path: '/call-stats/call-hangup-reports',
        name: routes_names.call_stats_call_hangup_reports,
        component: () => import('@/views/app/call-stats/CallHangupReports.vue'),
        meta: {
          title: 'Call Hangup Reports',
        },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
]
